var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.current,{tag:"component",style:(_vm.cssVars)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }